module.exports = __webpack_public_path__ + "img/lost-property.23bda9ca.jpg";